import {
  adviceActions,
  adviceSelectors,
  adviceState,
} from '@/lib/store/advice.store';
import { logger } from '@/lib/utils';
import { MetricsAction, MetricsCategory } from '@/lib/utils/metrics.utils';
import { useEffect, useRef } from 'react';
import { useMetrics } from './useMetrics';

export function useHandleChatNavigation(chatId: string | null) {
  const { trackEvent, trackFeature } = useMetrics();
  const fetchedChatIdRef = useRef<string | null>(null);
  const isInternalNavRef = useRef(false);

  useEffect(() => {
    logger.debug('[page] URL chatId changed', {
      chatId,
      currentChatId: adviceState.currentChatId.get(),
      isPending: adviceSelectors.isPending(),
      fetchedChatId: fetchedChatIdRef.current,
      isInternalNav: isInternalNavRef.current,
    });
    if (!chatId) return;
    if (isInternalNavRef.current) {
      isInternalNavRef.current = false;
      return;
    }
    if (fetchedChatIdRef.current === chatId) {
      return;
    }
    if (
      !adviceSelectors.isPending() &&
      chatId !== adviceState.currentChatId.get()
    ) {
      trackEvent({
        category: MetricsCategory.INTERACTION,
        action: MetricsAction.PAGE_VIEW,
        label: 'Chat View',
        value: 0,
        dimensions: { chatId },
      });

      adviceActions
        .fetchConversation(chatId)
        .then(() => {
          fetchedChatIdRef.current = chatId;
          logger.debug('[page] Chat fetch completed', { chatId });

          trackFeature('Chat Loaded');
        })
        .catch((error) => {
          logger.warn('[page] Failed to fetch conversation:', error);

          trackEvent({
            category: MetricsCategory.ERROR,
            action: MetricsAction.CLIENT_ERROR,
            label: 'Chat Load Failed',
            value: 0,
            dimensions: {
              chatId,
              error: error instanceof Error ? error.message : 'Unknown error',
            },
          });
        });
    }
  }, [chatId, trackEvent, trackFeature]);

  return { isInternalNavRef };
}
